export default __webpack_public_path__ + "static/media/certlayout_myanmar.31df59b0.png";